/**
 * Image URL exports for use in components.
 * Physical files live in assets/png/ and are bundled by webpack (asset/resource).
 * The *.png wildcard declaration in declarations.d.ts provides the type.
 */
import _noDataLightMode from "../../assets/png/no-data-light-mode.png";
import _unableToFetchData from "../../assets/png/light-mode-unable-to-fetch-data.png";

export const noDataLightMode = _noDataLightMode as string;
export const unableToFetchData = _unableToFetchData as string;
